(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneFileImageLoader", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneFileImageLoader"] = factory();
	else
		root["cornerstoneFileImageLoader"] = factory();
})(window, function() {
return 